// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__u6eHe","sticky":"Sidebar_sticky__ZrNT_","sectionLinks":"Sidebar_sectionLinks__OyCe0"};